// import { Controller } from "@hotwired/stimulus"
import { Ajax } from "../ajax"

import { Controller } from "stimulus"

// import tinymce from 'tinymce/tinymce'
// import 'tinymce/themes/modern/theme';
// //import 'tinymce/skins/lightgray/skin.min.css';

// import 'tinymce/plugins/image';
// import 'tinymce/plugins/lists';
// import 'tinymce/plugins/autosave';

export default class extends Controller {

  static targets = [ "editorSaveButton", "editor" ]
  static values = { url: String }

  connect() {
    let controller = this

    if (typeof tinymce !== 'undefined') {
      tinymce.editors.forEach((ed) => {
        ed.remove()
      })


      this.editorTargets.forEach((el) => {
        tinymce.init({
          content_css: "/assets/main.css",
          selector: "#" + el.getAttribute("id"),
          toolbar: "undo redo | bold italic | bullist numlist | indent outdent | removeformat",
          menubar: false,
          plugins: "image lists",
          height: "100%",
          statusbar: false,
          branding: false,
          body_id: "user-tinymce",
          invalid_elements: "embed,object",
          setup: (ed) => {
            ed.on("Change Redo Undo input", (e) => {
              this.editorContentChanged(ed.targetElm);
            })
          }
        });
      })
    }

  }

  saveEditorContent(e) {
    let id = e.currentTarget.dataset.id
    let content = tinymce.get(id).getContent()
    let text_content = tinymce.get(id).getContent({format: 'text'})

    Ajax.post(this.urlValue, {attribute: "notes", value: content}).then((response) => {
      tinymce.triggerSave()

      setTimeout(() => {
        this.editorSaveButtonTargets.forEach((el) => {
          el.classList.add('disabled');
          el.disabled = true;
        })
      }, 0)

    }).catch(() => {
      console.log('note fetch save editor content reject')
    });

  }

  editorContentChanged(originalEditor) {
    let originalContent = originalEditor.innerHTML;

    this.editorTargets.forEach((el) => {
      if (el != originalEditor && el.innerHTML != originalContent) {
        el.innerHTML = originalContent;
      }
    })

    this.editorSaveButtonTargets.forEach((el) => {
      el.classList.remove('disabled');
      el.disabled = false;
    })
  }

}